// @flow
import Targets from './Targets';

export default Targets;